/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */ import { css } from 'styled-components';
import { map } from '../../breakpoint';
// Flex Direction:
export const validFlexDirectionValues = [
    'row',
    'column',
    'row-reverse',
    'column-reverse'
];
export const flexDirection = ()=>css`
  ${({ flexDirection })=>map(flexDirection, (val)=>val && css`
          flex-direction: ${val};
        `)};
`;
// Flex Wrap:
export const validFlexWrapValues = [
    'wrap',
    'nowrap',
    'wrap-reverse'
];
export const flexWrap = ()=>css`
  ${({ flexWrap })=>map(flexWrap, (val)=>val && css`
          flex-wrap: ${val};
        `)};
`;
export const flexGrow = ()=>css`
  ${({ flexGrow })=>map(flexGrow, (val)=>val !== undefined && css`
          flex-grow: ${val};
        `)};
`;
export const flexShrink = ()=>css`
  ${({ flexShrink })=>map(flexShrink, (val)=>val !== undefined && css`
          flex-shrink: ${val};
        `)};
`;
// Flex Align Values - shared between align-items and align-self:
export const validFlexAlignValues = [
    'center',
    'flex-start',
    'flex-end',
    'stretch'
];
// Align Items:
export const alignItems = ()=>css`
  ${({ alignItems })=>map(alignItems, (val)=>val && css`
          align-items: ${val};
        `)};
`;
// Align Self:
export const alignSelf = ()=>css`
  ${({ alignSelf })=>map(alignSelf, (val)=>val && css`
          align-self: ${val};
        `)};
`;
// Justify Content:
export const validJustifyContentValues = [
    'center',
    'flex-start',
    'flex-end',
    'space-between',
    'space-around',
    'space-evenly'
];
export const justifyContent = ()=>css`
  ${({ justifyContent })=>map(justifyContent, (val)=>val && css`
          justify-content: ${val};
        `)};
`;

//# sourceMappingURL=flex.js.map